export const IA_KILL_SWITCH_GATE = 'nav:spring-spotlight-onboarding-fe';